import { CircularProgress, Typography } from '@mui/material';
import { AdverseMediaSection as AdverseMediaSectionComponent } from '@verifime/components';
import { useAdverseMediaData } from './hooks/useAdverseMediaData';

type TAdverseMediaViewProps = {
  customerId: string;
};

/**
 * The `AdverseMediaSection` view component provides a read-only display of adverse media history
 * for a customer. It combines data fetching with a clean presentation interface.
 *
 * This component:
 * - Fetches and displays adverse media history for a customer
 * - Shows loading states during data retrieval
 * - Handles and displays error states gracefully
 * - Provides a chronological view of adverse media assessments
 * - Displays comprehensive record details including timestamps and responsible users
 */
export default function AdverseMediaSection({ customerId }: TAdverseMediaViewProps) {
  const { history, isLoading, error } = useAdverseMediaData({ customerId });

  if (isLoading) {
    return (
      <Typography variant="body1">
        <CircularProgress /> Loading Adverse Media...
      </Typography>
    );
  }

  if (error) {
    return <Typography color="error">Failed to load adverse media information.</Typography>;
  }

  return <AdverseMediaSectionComponent history={history} />;
}
